import React, { useEffect } from "react";
import "./logodesign.css";
import AOS from "aos";
import "aos/dist/aos.css";

const logoDesignPlans = [
  {
    title: "Starter Logo",
    price: "₹2,499/-",
    subtitle: "Perfect for Individuals & Startups",
    features: [
      "1 Logo Concept",
      "High-Resolution PNG & JPEG",
      "1 Revision",
      "Standard Logo Guidelines",
      "Social Media Profile Picture Ready",
    ],
  },
  {
    title: "Professional Logo",
    price: "₹4,999/-",
    subtitle: "Best for Small & Medium Businesses",
    popular: true,
    features: [
      "3 Logo Concepts",
      "Vector Files (AI, EPS, PDF)",
      "3 Revisions",
      "Standard Logo Guidelines",
      "Social Media & Website Ready",
      "Favicon & App Icon",
    ],
  },
  {
    title: "Premium Logo",
    price: "₹7,999/-",
    subtitle: "For Enterprises & Brands",
    features: [
      "5 Logo Concepts",
      "Unlimited Revisions",
      "Vector Files (AI, EPS, PDF, SVG)",
      "Logo Guidelines & Branding Kit",
      "Social Media, Website & App Ready",
      "Favicon & App Icon",
      "Color Variations & B/W Version",
      "Priority Support",
    ],
  },
  {
    title: "Custom Logo",
    price: "₹ ???",
    subtitle: "Tailored Branding Solution",
    features: [
      "Custom Concepts & Revisions as Required",
      "Complete Branding Kit (Fonts, Colors, Icons)",
      "Logo Guidelines",
      "All File Formats",
      "Social Media, Website & App Ready",
      "Marketing Materials Ready",
      "Dedicated Designer Support",
      "Unlimited Revisions & Custom Requests",
    ],
  },
];

function LogoPricing() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: "ease-out",
    });
  }, []);

   const handleCall = () => {
    window.location.href = "tel:8778934301"; // opens phone dialer
  };


  return (
    <section className="pricing-section">
      <div className="container">
        <section className="section-margin">
          <div className="heading-for-all" data-aos="fade-up">
            <h2>Logo Design</h2>
          </div>
        </section>

        <div className="pricing-grid">
          {logoDesignPlans.map((plan, index) => (
            <div
              key={index}
              className={`pricing-card ${plan.popular ? "popular" : ""}`}
              data-aos="fade-up"
              data-aos-delay={index * 150} // Staggered delay effect
            >
              {plan.popular && <div className="popular-badge">POPULAR</div>}
              <h3 className="plan-title">{plan.title}</h3>
              <p className="plan-price">{plan.price}</p>
              <p className="plan-subtitle">{plan.subtitle}</p>
              <ul className="plan-features">
                {plan.features.map((feature, i) => (
                  <li key={i}>✅ {feature}</li>
                ))}
              </ul>
              <button className="choose-plan-btn" onClick={handleCall}>Choose Plan</button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default LogoPricing;
